


















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'

@Component({
  name: 'TableMenu',
  data() {
    return {
      titleUserActive: 'Total Category Visited',
      titleCategoryMaterials: 'Total Material Type Visited',
      alignCard: 'center',
      fieldsUserActive: [
        { key: 'no' },
        { key: 'title' },
        { key: 'total_visit' },
      ],
      fieldsCategoryMaterials: [
        { key: 'no' },
        { key: 'type_name' },
        { key: 'total_visit' },
      ],
    }
  },
})
export default class extends Vue {
  @Prop({}) public dataTable
  @Prop({}) public dataTableType
}
